import React from 'react'
import { Loader, useBreakpoints } from '@web/walter-ui-kit'

import { SettingsTabs } from '../Menu/const'
import { useSettingsModal } from '../useSettingsModal'
import { Preloader as SharedPreloader } from '../Preloader/SharedPreloader'
import { Preloader as IdentityPreloader } from '../tabs/Identity/Preloader'
import { Preloader as SecurityPreloader } from '../tabs/Security/Preloader'
import { Preloader as AccountPreloader } from '../tabs/Account/Preloader'
import { Preloader as SessionsPreloader } from '../tabs/ActiveSessions/Preloader'
import { Preloader as GeneralPreloader } from '../tabs/General/Preloader'
import commonStyles from '../style.module.css'
import styles from './style.module.css'
import { useAccountUserInfo, useTotps, useUserInfo, useVerificationLevels } from '~api'

const Preloaders = {
    [SettingsTabs.menu]: <SharedPreloader />,
    [SettingsTabs.general]: <GeneralPreloader />,
    [SettingsTabs.account]: <AccountPreloader />,
    [SettingsTabs.identity]: <IdentityPreloader />,
    [SettingsTabs.security]: <SecurityPreloader />,
    [SettingsTabs.sessions]: <SessionsPreloader />,
}

interface Props {
    withAction?: boolean
    isSmallAction?: boolean
}

export function CellLoader({ withAction = true, isSmallAction = false }: Props) {
    return (
        <div className={styles.cell}>
            <Loader isCircled width={40} height={40} />
            <div className={styles.title}>
                <Loader width={100} height={18} />
                <Loader width={210} height={14} />
            </div>

            {withAction && (
                <div className={styles.action}>
                    <Loader width={isSmallAction ? 24 : 70} height={isSmallAction ? 24 : 20} />
                </div>
            )}
        </div>
    )
}

function Preloader() {
    const { tab } = useSettingsModal()
    const { isMobile } = useBreakpoints()

    // Data preload
    useTotps({ shouldRequest: tab === SettingsTabs.security })
    useAccountUserInfo({ shouldRequest: tab === SettingsTabs.identity })
    useVerificationLevels({ shouldRequest: tab === SettingsTabs.identity })
    useUserInfo({ shouldRequest: tab === SettingsTabs.account })

    const preloader = Preloaders[tab] ?? null

    const showTabPreloader = tab !== SettingsTabs.menu
    const showMenuPreloader = (() => {
        if (!isMobile) {
            return true
        }

        return tab === SettingsTabs.menu
    })()

    return (
        <div className={commonStyles.modalWrap} data-pointer="settings_modal_content_preloader">
            <div className={styles.content}>
                {showMenuPreloader && (
                    <div className={styles.nav}>
                        {Array(5)
                            .fill(0)
                            .map((_, index) => (
                                <div key={index} className={styles.navItem}>
                                    <Loader isCircled width={24} height={24} />
                                    <div className={styles.navTitle}>
                                        <Loader width={148} height={20} borderRadius="xs" />
                                    </div>
                                    {isMobile && (
                                        <div className={styles.chevron}>
                                            <Loader width={20} height={24} />
                                        </div>
                                    )}
                                </div>
                            ))}
                    </div>
                )}

                {showTabPreloader && preloader}
            </div>
        </div>
    )
}

export default Preloader
